import { Text, Input } from 'ui'
import { Button, Div } from 'ui'
import { useEffect } from 'react'
import { PHONE_CODES } from 'config/phoneCodes'
import { ReactComponent as InfoSVG } from 'assets/icons/info.svg'
import { Info } from './styles'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import { isValid } from 'ui/Input/validators'

const formatOptionLabel = ({ value, label }, meta) => {

  if (meta.context === 'value') {
    return `${label} (${value})`
  }

  return (
    <Div display='flex' justifyContent='space-between'>
      <span>
        {label}
      </span>
      <span>
        {value}
      </span>
    </Div>
  )
}


const FormPhoneNumber = ({
  title,
  country,
  setCountry,
  defaultCountryCode = '+54',
  mobileNumber,
  setMobileNumber,
  onSubmit,
  isLoading,
  showInfo,
  error: customError
}) => {

  const { t } = useTranslation()

  const [error, setError] = useState(customError)

  const mobileNumberFull = `${country?.value}${mobileNumber}`


  const handlePhoneNumber = (value) => {
    const re = new RegExp('^[0-9]{0,}$')
    if (!re.test(value)) return
    setError('')
    setMobileNumber(value)
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    if (!isValid.mobileNumber(mobileNumberFull)) {
      setError(t('mobileNumberInvalid'))
      return
    }
    
    onSubmit({ mobileNumber: mobileNumberFull })
  }

  const options = PHONE_CODES.map(country => ({
      label: country.name,
      value: country.code
    }))

  useEffect(() => {
    const defaultCountry = options.find(c => c.value === defaultCountryCode)
    setCountry(defaultCountry)
  }, [])


  useEffect(() => {
    setError(customError)
  }, [customError])


  return (
    <Div as='form' onSubmit={handleSubmit} width='100%'>
      <Text size='xl' weight='semibold' color='headline' align='center'>
        {title}
      </Text>

      <Div
        display='flex'
        flexDirection='column'
        gap={16}
        marginTop={32}
        marginBottom={16}
      >
        <Input.Select
          size='large'
          options={options}
          onChange={setCountry}
          selected={country}
          formatOptionLabel={formatOptionLabel}
        />

        <Input.Text
          size='large'
          name='phone'
          label={t('mobileNumber')}
          onChange={handlePhoneNumber}
          value={mobileNumber}
          error={error}
        />

        {showInfo && (
          <Info>
            <InfoSVG />
            <Text size='xs' color='headline'>
              {t('mobileInfo')}
            </Text>
          </Info>
        )}
      </Div>

      <Div marginTop={showInfo ? 160 : 250}>
        <Button
          isFull
          size='large'
          disabled={!mobileNumber}
          isLoading={isLoading}
        >
          {t('next')}
        </Button>
      </Div>

    </Div>
  )
}

export default FormPhoneNumber